var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 30C15.0002 27.2386 17.2387 25 20.0002 25C22.7616 25 25.0002 27.2386 25.0002 30V36.6667H15.0002V30Z",
    stroke: "#25A249",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 13.3334C3.3335 11.4924 4.82588 10 6.66683 10H10.4976C11.2545 10 11.9888 9.74245 12.5799 9.26961L17.9178 4.99924C19.1352 4.02532 20.8651 4.02532 22.0825 4.99924L27.4205 9.26961C28.0115 9.74245 28.7459 10 29.5028 10H33.3335C35.1744 10 36.6668 11.4924 36.6668 13.3334V33.3334C36.6668 35.1743 35.1744 36.6667 33.3335 36.6667H6.66683C4.82588 36.6667 3.3335 35.1743 3.3335 33.3334V13.3334Z",
    stroke: "#25A249",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3335 16.6667C23.3335 14.8258 21.8411 13.3334 20.0002 13.3334C18.1592 13.3334 16.6668 14.8258 16.6668 16.6667C16.6668 18.5077 18.1592 20 20.0002 20C21.8411 20 23.3335 18.5077 23.3335 16.6667Z",
    stroke: "#25A249",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrs);
export default __webpack_public_path__ + "static/media/crs.9fa4b1a2423c7bacc2d6b0f28a068ecd.svg";
export { ForwardRef as ReactComponent };